import React, { useMemo } from 'react'
import { CompletionStatus } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Icon from '@divvy-web/skylab.icon'

import styles from './styles.module.scss'

interface ApplicationProgressProps {
  status?: CompletionStatus | null
}

const radius = 7
const circumference = 2 * Math.PI * radius

const ApplicationProgress = ({ status }: ApplicationProgressProps) => {
  const [getClassName, makeTestId] = useNameFormatter('ApplicationProgress')

  const progress = useMemo(() => {
    switch (status) {
      case CompletionStatus.COMPLETED:
        return 100
      case CompletionStatus.PARTIAL:
        return 50
      case CompletionStatus.UNSTARTED:
      default:
        return 0
    }
  }, [status])

  if (progress >= 100) {
    return (
      <Icon
        className={styles[getClassName('complete')]}
        dataTestId={makeTestId('complete')}
        name='checkCircleFilled'
      />
    )
  }

  return (
    <i
      aria-hidden='true'
      className={styles[getClassName('progress-container')]}
      data-testid={makeTestId('progress-container')}
    >
      <svg
        className={styles[getClassName('progress-icon')]}
        data-testid={makeTestId(`progress-icon-${progress}`)}
        fill='none'
        viewBox='0 0 20 20'
      >
        <circle
          className={styles[getClassName('circle')]}
          cx='10'
          cy='10'
          fill='transparent'
          r={radius}
          strokeDasharray='2'
        />
        <circle
          className={styles[getClassName('circle')]}
          cx='10'
          cy='10'
          fill='transparent'
          r={radius}
          strokeDasharray={`${circumference}px`}
          strokeDashoffset={`${circumference * ((100 - progress) / 100)}px`}
        />
      </svg>
    </i>
  )
}

export default ApplicationProgress
